module.exports = __webpack_public_path__ + "media/sfx-opening.37c25d0e.ogg";